export default {
  NO_PAUSE: '你的暂停次数已经用完了，不能退出',
  ZERO: '我们无法听到您的声音，请再大点声，或检查下你的设备录音功能是否正常',
  NEW_CONTENT: '新的内容开启了',
}
